export default __webpack_public_path__ + "static/media/enjeux-treso.c0159b45.png";